export function AdvisorSummary({ advisor }: { advisor: Advisor }) {
  return (
    <div className="border-b pb-4">
      <h3 className="text-lg font-medium">Advisor Information</h3>
      <div className="mt-2 text-sm text-gray-700">
        <p>
          <strong>ID:</strong> {advisor.advisorId}
        </p>
        <p>
          <strong>Name:</strong> {advisor.advisorFirstName}{' '}
          {advisor.advisorLastName}
        </p>
        <p>
          <strong>Email:</strong> {advisor.advisorEmail}
        </p>
        <p>
          <strong>Organization:</strong>{' '}
          {advisor.organizationDisplayName ||
            advisor.organizationName ||
            'N/A'}
        </p>
      </div>
    </div>
  );
}
